import { Metavalue, Metavalues, Result } from "@peercolab/engine";
import { Published } from "../peer-colab-model/PetKey/Main/Model/1_0_Initial/Backoffice/Core/PathItems";

export function onRevert<R>(result: Result<R>, revert: () => void): Result<R> {
  if (!result.success) {
    revert();
  }
  return result;
}

export function handleInPlaceMoveSortOfIdElement(items: { sortId: number }[], index: number, direction: string): void {
  const [moved] = items.splice(index, 1);
  let targetIdx = index;
  switch (direction) {
    case 'up':
      targetIdx = Math.max(index - 1, 0);
      break;
    case 'down':
      targetIdx = Math.min(index + 1, items.length);
      break;
    case 'top':
      targetIdx = 0;
      break;
    case 'bottom':
      targetIdx = items.length;
      break;
  }
  items.splice(targetIdx, 0, moved);
  items.forEach((b, i) => b.sortId = i + 1)
}

export function transitionState(meta: Metavalues, currentState: Published, action: string): Published {
  switch (action) {
    case 'publish':
      meta.add(Metavalue.with(action, undefined))
      return { state: 'published', lastPublishedAt: new Date(), isDirty: false };
    case 'unpublish':
      meta.add(Metavalue.with(action, undefined))
      return { state: 'draft', lastPublishedAt: undefined, isDirty: false };
    case 'revert':
      meta.add(Metavalue.with(action, undefined))
      return currentState;
  }
  return currentState;
}

export function applyStateTransition<T>(
  dbPublished: T[], 
  existingPublishedIndex: number, 
  meta: Metavalues, 
  updated: T, 
  state: Published,
  onStateUpdate: (item: T, newState: Published) => T
): T {
  if (meta.hasMetaValue('publish')) {
    if (existingPublishedIndex === -1) {
      dbPublished.push(JSON.parse(JSON.stringify(updated)));
    } else {
      dbPublished[existingPublishedIndex] = JSON.parse(JSON.stringify(updated));
    }
  } else if (meta.hasMetaValue('unpublish')) {
    if (existingPublishedIndex !== -1) {
      dbPublished.splice(existingPublishedIndex, 1);
    }
  } else if (meta.hasMetaValue('revert')) {
    if (existingPublishedIndex !== -1) {
      return JSON.parse(JSON.stringify(dbPublished[existingPublishedIndex]));
    }
  } else {
    if (state.state === 'published') {
      return onStateUpdate(updated, { ...state, isDirty: true });
    }
  }
  return updated;
}
